import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MlModel } from '../../models/mlmodel/mlModel.model';
import { GlobalService } from '../../services/global.service';
import { MLService } from '../../services/ml-service';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { NgForm, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FlowSheetService } from '../../services/flowsheet-service';
import { Model } from '../../models/flowsheet/Model.model';
import { DataSrc } from '../../models/flowsheet/flowsheet.model';
import { InputParameter } from '../../models/flowsheet/inputParameters.model';
import { FlowSheetEventsHandler } from '../../flowsheet/flowsheet-events/flowsheet.events.handler';
import { concatMap, map, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ParameterModel } from 'src/app/models/flowsheet/parameter.model';

@Component({
  selector: 'app-data-source-manager',
  templateUrl: './data-source-manager.component.html',
  styleUrls: ['./data-source-manager.component.css']
})

export class DataSourceManagerComponent implements OnInit {

  model: Model = new Model();
  inputParameters = [];
  srcConnParameterList = [];
  sinkConnParameterList = [];
  sinkModel = new MlModel();
  sinkConnVariablesList: InputParameter[] = [];
  sinkVariablesConnToSrcModel: InputParameter[] = [];
  srcConnVariablesList = [];
  dataToPass = [];
  userSinkVar = false;
  form_template = [];
  @ViewChild('f', { static: true }) registerForm: NgForm;
  modelError: string;
  myFormGroup: UntypedFormGroup;
  connSetUserData = [];
  deletedSinkParam: InputParameter;
  readOnly: false;
  isLoading = false;
  dataSource;
  dataSourceSelected;
  dataSourceName;
  parameterList: any[];
  selectedParameter;
  frequncy = 120;
  public destroyed = new Subject<any>();
  parameterModel = new ParameterModel();

  constructor(public dialogRef: MatDialogRef<DataSourceManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: GlobalService,
    public mlService: MLService,
    public flowsheetService: FlowSheetService,
    public flowSheetHandler: FlowSheetEventsHandler,
    public dialog: MatDialog) {
  };

  ngOnInit() {
    this.getDataSources();
    this.isLoading = true;
    this.dialogRef.disableClose = true;

    this.model = this.data.model;
    this.readOnly = this.data.readOnly;
    this.inputParameters = this.model.inputParameters;
    this.setConnectedParameters();
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  setConnectedParameters() {
    this.sinkConnVariablesList = this.model.inputParameters.filter(p => p.mappedDataSource == DataSrc.extDataSrc);
    this.inputParameters = this.model.inputParameters.filter(p => p.mappedDataSource == DataSrc.user);
    this.sinkVariablesConnToSrcModel = this.model.inputParameters.filter(p => p.mappedDataSource == DataSrc.model);

    this.sinkConnVariablesList.forEach((param) => {
      let srcParameterData = {
        mappedDataSource: param.mappedDataSource,
        mappedDataSourceId: param.mappedDataSourceId,
        mappedFrequency: param.mappedFrequency,
        mappedParameterId: param.mappedParameterId,
        mappedParameterName: param.mappedParameterName,
        mappedParameterUoM: param.mappedParameterUoM
      };
      this.srcConnVariablesList.push(srcParameterData);
    });
  }

  getDataSources() {
    let dataSource
    this.flowsheetService.getDataSources()
      .pipe(
        takeUntil(this.destroyed),
        map((data: any) => {
          this.dataSource  = data;
          this.dataSourceSelected = this.dataSource[0];
          this.getDataSourceParameters();
        })
      ).subscribe(
        (error) => {
          this.modelError = 'Failed to load Data sources.'; this.isLoading = false;
        }
      )
  }

  getDataSourceParameters() {
    this.isLoading = true;
    this.flowsheetService.getDataSourceParameters(this.dataSourceSelected.dataSourceId).subscribe((data: any): void => {
      this.parameterList = data;
      this.isLoading = false;
    }, (error: Error) => { this.modelError = 'Failed to load data source parameters.'; this.isLoading = false; });
  }

  drop(event) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  deleteMapping(index) {
    this.srcConnVariablesList.splice(index, 1);
    if (this.sinkConnVariablesList[index]) {
      this.deletedSinkParam = this.sinkConnVariablesList.splice(index, 1)[0];
      this.flowSheetHandler.resetParameterSrcMapData(this.deletedSinkParam);
      this.flowSheetHandler.returnParameterToOriginalPosition(this.inputParameters, this.deletedSinkParam);
    }
  }

  onSelectParameter(parameter) {
    let srcParameterData = {
      mappedDataSource: DataSrc.extDataSrc,
      mappedDataSourceId: this.dataSourceSelected.dataSourceId,
      mappedFrequency: this.frequncy,
      mappedParameterId: parameter.srcParameterId,
      mappedParameterName: parameter.srcParameter,
      mappedParameterUoM: ''
    };
    this.srcConnVariablesList.push(srcParameterData);
    this.selectedParameter = undefined;
  }

  saveMappingDetails() {
    if (this.inputParameters.length === 0) {
      this.saveDataSourceMapping();
      this.dialogRef.close(false);
    }
    else {
      this.userSinkVar = true;
      let formItem = [];
      let group = {};

      for (let i = 0; i < this.inputParameters.length; i++) {
        if (this.inputParameters[i].mappedDataSource === DataSrc.user) {
          let obj = {};
          obj['inputModel'] = this.inputParameters[i].data.parameterName + "-" + this.inputParameters[i].data.parameterId;
          obj['label'] = this.inputParameters[i].data.captionName;
          obj['uom'] = this.inputParameters[i].data.parameterUom;
          obj['value'] = this.inputParameters[i].data.parameterDefaultValue;
          if (obj['value'] == null || typeof (this.inputParameters[i].data.parameterDefaultValue) === 'string') {
            obj['type'] = 'textBox';
          } else if (obj['value'] == null || typeof (this.inputParameters[i].data.parameterDefaultValue) === 'number') {
            obj['type'] = 'number';
          } else {
            obj['type'] = 'checkbox';
          }
          formItem.push(obj);
        }
      }
      this.form_template = formItem;
      this.form_template.forEach(input_template => {
        group[input_template.inputModel] = new UntypedFormControl(input_template.value);
      })
      this.myFormGroup = new UntypedFormGroup(group);
    }
  }

  gotoPrev() {
    this.userSinkVar = false;
  }

  onSubmit() {
    for (let [key, value] of Object.entries(this.myFormGroup.value)) {
      let res = key.split('-');

      this.parameterModel.model = this.model;
      this.parameterModel.parameterId = res[1];
      this.parameterModel.dataSource = DataSrc.user;
      this.parameterModel.dataSourceId = 1;
      this.parameterModel.srcFrequency = 0;
      this.parameterModel.srcParameterId = 0;
      this.parameterModel.srcParameterName = '';
      this.parameterModel.srcParameterUoM = '';
      this.parameterModel.defaultValue = value;

      this.flowSheetHandler.updateParameterMapping(this.parameterModel);
    }
    this.saveDataSourceMapping();
    this.dialogRef.close(false);
  }

  saveDataSourceMapping() {
    this.sinkConnVariablesList.forEach((connParam, index) => {

      let srcParam = this.srcConnVariablesList[index];

      this.parameterModel.model = this.model;
      this.parameterModel.parameterId = connParam.data.parameterId
      this.parameterModel.dataSource = DataSrc.extDataSrc;
      this.parameterModel.dataSourceId = srcParam.mappedDataSourceId;
      this.parameterModel.srcFrequency = srcParam.mappedFrequency;
      this.parameterModel.srcParameterId = srcParam.mappedParameterId;
      this.parameterModel.srcParameterName = srcParam.mappedParameterName;
      this.parameterModel.srcParameterUoM = srcParam.mappedParameterUoM;
      this.parameterModel.defaultValue = connParam.data.parameterDefaultValue;

      this.flowSheetHandler.updateParameterMapping(this.parameterModel);
    });
  }

}
